import React from "react";
import { useNavigate } from "react-router-dom";
import {Button, Typography, Paper, Box} from '@mui/material';
import Header from "../Common/Header/Header";
import Sidenav from "../Common/Sidenav/Sidenav";
import router from "../../routePaths/routePaths";

export default function SelectDomain() {
    let navigate = useNavigate();

    return (
        <div>
            <Header />
            <div className="main-container my-3">
                <div className="row m-2">
                    <div className="col-lg-2 col-xl-2 d-none d-lg-block d-xl-block">
                        <Sidenav/>
                    </div>
                    <div className="col-lg-10 col-xl-10">
                        <Paper elevation={2} sx={{ width: '100%', p: 3}}>
                            <div classNmae="row">
                                <Typography>
                                    Please select Database
                                </Typography>
                            </div>
                            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                <Button className="btn btn-blue px-3 mx-2 fit-content" onClick={()=>navigate(router.select_profile+'/Dev')}>
                                    Dev
                                </Button>
                                <Button className="btn btn-blue px-3 mx-2 fit-content" onClick={()=>navigate(router.select_profile+'/Preprod')}>
                                    Preprod
                                </Button>
                                <Button className="btn btn-blue px-3 mx-2 fit-content" onClick={()=>navigate(router.select_profile+'/Prod')}>
                                    Prod
                                </Button>
                            </Box>
                            <div className="row">
                            </div>
                        </Paper>
                    </div>
                </div>
            </div>
        </div>
    );
}
